import i18n from '@/i18n'
/**
 * Created by PanJiaChen on 16/11/18.
 */

 import {CodeToText } from 'element-china-area-data'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return [i18n.t('utils.index.2595930-0'), i18n.t('utils.index.2595930-1'), i18n.t('utils.index.2595930-2'), i18n.t('utils.index.2595930-3'), i18n.t('utils.index.2595930-4'), i18n.t('utils.index.2595930-5'), i18n.t('utils.index.2595930-6')][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return i18n.t('utils.index.2595930-7')
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + i18n.t('utils.index.2595930-8')
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + i18n.t('utils.index.2595930-9')
  } else if (diff < 3600 * 24 * 2) {
    return i18n.t('utils.index.2595930-10')
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      i18n.t('utils.index.2595930-11') +
      d.getDate() +
      i18n.t('utils.index.2595930-0') +
      d.getHours() +
      i18n.t('utils.index.2595930-12') +
      d.getMinutes() +
      i18n.t('utils.index.2595930-13')
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout; let args; let context; let timestamp; let result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source || typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * 组织结构过滤
 */
export function orgFormatDict(data, prop) {
  const { label, value } = prop
  const result = []

  function format(arr) {
    arr.forEach(item => {
      if (item.level < 4 && item.children) {
        format(item.children)
      }
      if (item.level === 4 && item.children) {
        item.label = item[label]
        item.value = item[value]
        // 展开到6级（扁平化5级）
        const list = []
        item.children.forEach(i => {
          list.push(...(i.children || []).map(j => ({
            label: j[label],
            value: j[value]
          })))
        })
        item.children = list
        result.push(item)
      }
    })
  }

  format(data)
  return result
}

/**
 * key名称统一成为 label value children（用于数据字典数据）
 */
export function formatDict(data, prop = {}, deep) {
  const { label, value, children } = prop

  function format(arr) {
    return arr.map(item => {
      const childrenData =
        item[children || 'children'] && item[children || 'children'].length
          ? format(item[children || 'children'], item[value || 'value'])
          : null
      return {
        label: item[label || 'label'],
        value: item[value || 'value'],
        children: deep
          ? Number(item.level) - 1 < deep
            ? childrenData
            : null
          : childrenData,
        _children: childrenData
      }
    })
  }

  return format(data)
}

/**
 * 数据字典code 转 text
 * data: 数据字典值
 * code：需要转换的code
 * 注意：地区编码请使用插件自带的CodeToText对象
 */

export const dictCodeToText = (data, code) => {
  if (!data || code === undefined) {
    return ''
  }
  const Obj = {}

  // 转成Obj
  function getLabel(arr) {
    for (let i = 0; i < arr.length; i++) {
      Obj[arr[i].value] = arr[i].label
      if (arr[i].children) {
        getLabel(arr[i].children)
      }
    }
  }

  getLabel(data)

  // 处理多层结构
  function codeToArrLabel(codeList) {
    function toText(arr) {
      if (Array.isArray(arr)) {
        return arr.map(item => toText(item))
      } else {
        return Obj[arr]
      }
    }

    return toText(codeList)
  }

  if (Array.isArray(code)) {
    return codeToArrLabel(code)
  } else {
    return Obj[code] || ''
  }
}

/**
 * 多层地区编码转text
 */
 export function cascadeAreaToText(data) {
  if (Array.isArray(data)) {
    return data.map(item => cascadeAreaToText(item))
  } else {
    return CodeToText[data]
  }
}

export function sortKey(fileData) {
  let keys = Object.keys(fileData)
  let sortKeys = keys.sort();
  let newData = {}
  sortKeys.forEach(key => {
    for (let k in fileData) {
      if (key === k) {
        newData[key] = fileData[k]
      }
    }
  })
  return newData
}
